import React from 'react';
import TableList from '../shared/TableList.js';
import useFeatureChecker, { AllowedFeature, DeniedFeature } from '../shared/FeatureChecker.js'
import { Link } from 'react-router-dom'
import { DestroyButton } from '../shared/Buttons.js';
import {  useMutation } from 'react-query'
import { useMutationClient } from '../shared/hooks.js'
import { useNotifications } from '../shared/Notifications.js'

export default function DigitalsImplementationTable({ implementation, refetch }) {
  const CheckFeatures = useFeatureChecker()
  const mutationClient = useMutationClient()
  const notifications = useNotifications()

  const mutation = useMutation(data => mutationClient.delete(`logsdigitals/`), {
      onSuccess: (data, variables, context) => {
        if (data.status === 200) {
          notifications.success('Implementación eliminada')
        }
      },
      onError: () => {
        notifications.danger('Ha ocurrido un error al eliminar la implemtación')
      }
  })

  
  if (!implementation.length) {
    return <div className="not-found-table-items">No se encontraron implemntaciones</div>
  }

  

  return (
    <TableList>
      <TableList.Header>
        <TableList.HeaderItem value="Identificador" />
        <TableList.HeaderItem value="Nombre" />
        <TableList.HeaderItem value="Plataforma" />
        <TableList.HeaderItem/>
      </TableList.Header>

      <TableList.Body>
        {
          implementation.map(item => (
            <TableList.Row key={item.uuid}>
              <TableList.Column>
                <CheckFeatures feature = 'DETAIL_IMPLEMENTATION'>
                    <AllowedFeature>
                      <Link className="py-3" to={"/digitals/implementation/" + item.uuid}>
                        <span>{item.uuid}</span>
                      </Link>
                    </AllowedFeature>
                    <DeniedFeature>
                      {item.uuid}
                    </DeniedFeature>
                  </CheckFeatures>
              </TableList.Column>
              <TableList.Column>
                {item.name}
              </TableList.Column>
               <TableList.Column>
             {
                item.platform === "GCP" ? 
                item.platform : 
                (item.extra ? `${item.platform} (${item.extra})` : item.platform)
              }
                
              </TableList.Column>
              <TableList.Column >
                <CheckFeatures feature = 'DESTROY_IMPLEMENTATION'>
                  <DestroyButton
                    label="Eliminar"
                    confirmMessage="¿Está seguro que desea eliminar la implementación?"
                    successMessage="Implementación eliminada correctamente"
                    errorMessage={"Implementación no ha podido ser eliminada"}
                    deletePath={`/logsdigitals/${item.uuid}`}
                    refetch={refetch}
                  />
                </CheckFeatures>
              </TableList.Column>
            </TableList.Row>
          ))
        }
      </TableList.Body>
    </TableList>
  )
}
